import { Route, Routes } from "react-router";
import PageTurnTransition from "./components/PageTurnTransition";

// Japanese Pages
import Top from "./pages/Top";
import Contact from "./pages/Contact";
import Datenschutzerklarung from "./pages/Datenschutzerklarung";
import Impressum from "./pages/Impressum";
import CookiePolicy from "./pages/CookiePolicy";
import Agb from "./pages/Agb";
import ContactThanks from "./pages/ContactThanks";
import Work from "./pages/Work";
import WebSite from "./pages/WebSite";
import Branding from "./pages/Branding";
import Marketing from "./pages/Marketing";
import Company from "./pages/Company";
// import HayashiseimenjoLp from "./pages/work/HayashiseimenjoLp";
// import AlfaManagementCorporate from "./pages/work/AlfaManagementCorporate";
// import AmesankohEc from "./pages/work/AmesankohEc";
// import AmesankohLp from "./pages/work/AmesankohLp";
// import AmesankohjpCorporate from "./pages/work/AmesankohjpCorporate";
// import AquadianaCorporate from "./pages/work/AquadianaCorporate";
// import ArtdeliLp from "./pages/work/ArtdeliLp";
// import DaeyangEc from "./pages/work/DaeyangEc";
// import DaeyangSns from "./pages/work/DaeyangSns";
// import EurojcupTote from "./pages/work/EurojcupTote";
// import HayashiseimenjoSns from "./pages/work/HayashiseimenjoSns";
// import ImoriichibaEc from "./pages/work/ImoriichibaEc";
// import ImoriichibaTote from "./pages/work/ImoriichibaTote";
// import JapanfesNovelty from "./pages/work/JapanfesNovelty";
// import LogotChara from "./pages/work/LogotChara";
// import MarukinkaraageLp from "./pages/work/MarukinkaraageLp";
// import OrenorheingawaBlog from "./pages/work/OrenorheingawaBlog";
// import RamennobuUniform from "./pages/work/RamennobuUniform";
// import TagawaTote from "./pages/work/TagawaTote";
// import TagawaUniform from "./pages/work/TagawaUniform";
// import TransfoodlevEc from "./pages/work/TransfoodlevEc";
// import JapanfesUniform from "./pages/work/JapanfesUniform";
// import NeotokyocardsEc from "./pages/work/NeotokyocardsEc";
// import SpogomiUniform from "./pages/work/SpogomiUniform";
// import ToiUniform from "./pages/work/ToiUniform";
// import FckreisUniform from "./pages/work/FckreisUniform";
// import AmesankohProductDaruma from "./pages/work/AmesankohProductDaruma";

// English Pages
import ContactEn from "./pages/en/Contact";
import DatenschutzerklarungEn from "./pages/en/Datenschutzerklarung";
import ImpressumEn from "./pages/en/Impressum";
import CookiePolicyEn from "./pages/en/CookiePolicy";
import AgbEn from "./pages/en/Agb";
import ContactThanksEn from "./pages/en/ContactThanks";
import TopEn from "./pages/en/Top";
import CompanyEn from "./pages/en/Company"
import WorkEn from "./pages/en/Work"
import WebSiteEn from "./pages/en/WebSite"
import BrandingEn from "./pages/en/Branding"
import MarketingEn from "./pages/en/Marketing"
// import HayashiseimenjoLpEn from "./pages/en/work/HayashiseimenjoLp";
// import AlfaManagementCorporateEn from "./pages/en/work/AlfaManagementCorporate";
// import AmesankohEcEn from "./pages/en/work/AmesankohEc";
// import AmesankohLpEn from "./pages/en/work/AmesankohLp";
// import AmesankohjpCorporateEn from "./pages/en/work/AmesankohjpCorporate";
// import AquadianaCorporateEn from "./pages/en/work/AquadianaCorporate";
// import ArtdeliLpEn from "./pages/en/work/ArtdeliLp";
// import DaeyangEcEn from "./pages/en/work/DaeyangEc";
// import DaeyangSnsEn from "./pages/en/work/DaeyangSns";
// import EurojcupToteEn from "./pages/en/work/EurojcupTote";
// import HayashiseimenjoSnsEn from "./pages/en/work/HayashiseimenjoSns";
// import ImoriichibaEcEn from "./pages/en/work/ImoriichibaEc";
// import ImoriichibaToteEn from "./pages/en/work/ImoriichibaTote";
// import JapanfesNoveltyEn from "./pages/en/work/JapanfesNovelty";
// import LogotCharaEn from "./pages/en/work/LogotChara";
// import MarukinkaraageLpEn from "./pages/en/work/MarukinkaraageLp";
// import OrenorheingawaBlogEn from "./pages/en/work/OrenorheingawaBlog";
// import RamennobuUniformEn from "./pages/en/work/RamennobuUniform";
// import TagawaToteEn from "./pages/en/work/TagawaTote";
// import TagawaUniformEn from "./pages/en/work/TagawaUniform";
// import TransfoodlevEcEn from "./pages/en/work/TransfoodlevEc";
// import JapanfesUniformEn from "./pages/en/work/JapanfesUniform";
// import NeotokyocardsEcEn from "./pages/en/work/NeotokyocardsEc";
// import SpogomiUniformEn from "./pages/en/work/SpogomiUniform";
// import ToiUniformEn from "./pages/en/work/ToiUniform";
// import FckreisUniformEn from "./pages/en/work/FckreisUniform";
// import AmesankohProductDarumaEn from "./pages/en/work/AmesankohProductDaruma";

import WorkDetailTemplate from "./pages/work/WorkDetailTemplate";
import WorkDetailTemplateEn from "./pages/en/work/WorkDetailTemplate";


function App() {
  return (
    <>
      <PageTurnTransition>
        <Routes>
        {/* Japanese Pages */}
        <Route path='/' element={<Top />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/datenschutzerklarung' element={<Datenschutzerklarung />} />
        <Route path='/impressum' element={<Impressum />} />
        <Route path='/cookiePolicy' element={<CookiePolicy />} />
        <Route path='/agb' element={<Agb />} />
        <Route path='/contact/thanks' element={<ContactThanks />} />
        <Route path='/work' element={<Work />} />
        <Route path='/website' element={<WebSite />} />
        <Route path='/branding' element={<Branding />} />
        <Route path='/marketing' element={<Marketing />} />
        <Route path='/company' element={<Company />} />
        {/* <Route path='/work/hayashiseimenjoLp' element={<HayashiseimenjoLp />} />
        <Route path='/work/alfaManagementCorporate' element={<AlfaManagementCorporate />} />
        <Route path='/work/amesankohEc' element={<AmesankohEc />} />
        <Route path='/work/amesankohLp' element={<AmesankohLp />} />
        <Route path='/work/amesankohjpCorporate' element={<AmesankohjpCorporate />} />
        <Route path='/work/aquadianaCorporate' element={<AquadianaCorporate />} />
        <Route path='/work/artdeliLp' element={<ArtdeliLp />} />
        <Route path='/work/daeyangEc' element={<DaeyangEc />} />
        <Route path='/work/daeyangSns' element={<DaeyangSns />} />
        <Route path='/work/eurojcupTote' element={<EurojcupTote />} />
        <Route path='/work/hayashiseimenjoSns' element={<HayashiseimenjoSns />} />
        <Route path='/work/imoriichibaEc' element={<ImoriichibaEc />} />
        <Route path='/work/imoriichibaTote' element={<ImoriichibaTote />} />
        <Route path='/work/japanfesNovelty' element={<JapanfesNovelty />} />
        <Route path='/work/logotChara' element={<LogotChara />} />
        <Route path='/work/marukinkaraageLp' element={<MarukinkaraageLp />} />
        <Route path='/work/orenorheingawaBlog' element={<OrenorheingawaBlog />} />
        <Route path='/work/ramennobuUniform' element={<RamennobuUniform />} />
        <Route path='/work/tagawaTote' element={<TagawaTote />} />
        <Route path='/work/tagawaUniform' element={<TagawaUniform />} />
        <Route path='/work/transfoodlevEc' element={<TransfoodlevEc />} />
        <Route path='/work/japanfesUniform' element={<JapanfesUniform />} />
        <Route path='/work/neotokyocardsEc' element={<NeotokyocardsEc />} />
        <Route path='/work/spogomiUniform' element={<SpogomiUniform />} />
        <Route path='/work/toiUniform' element={<ToiUniform />} />
        <Route path='/work/fckreisUniform' element={<FckreisUniform />} />
        <Route path='/work/amesankohProductDaruma' element={<AmesankohProductDaruma />} /> */}
        <Route path="/work/:slug" element={<WorkDetailTemplate />} />


        {/* English　Pages */}
        <Route path='/en' element={<TopEn />} />
        <Route path='/en/contact' element={<ContactEn />} />
        <Route path='/en/datenschutzerklarung' element={<DatenschutzerklarungEn />} />
        <Route path='/en/impressum' element={<ImpressumEn />} />
        <Route path='/en/cookiePolicy' element={<CookiePolicyEn />} />
        <Route path='/en/agb' element={<AgbEn />} />
        <Route path='/en/contact/thanks' element={<ContactThanksEn />} />
        <Route path='/en/company' element={<CompanyEn />} />
        <Route path='/en/work' element={<WorkEn />} />
        <Route path='/en/website' element={<WebSiteEn />} />
        <Route path='/en/branding' element={<BrandingEn />} />
        <Route path='/en/marketing' element={<MarketingEn />} />
        <Route path='/en/company' element={<CompanyEn />} />
        {/* <Route path='/en/work/hayashiseimenjoLp' element={<HayashiseimenjoLpEn />} />
        <Route path='/en/work/alfaManagementCorporate' element={<AlfaManagementCorporateEn />} />
        <Route path='/en/work/amesankohEc' element={<AmesankohEcEn />} />
        <Route path='/en/work/amesankohLp' element={<AmesankohLpEn />} />
        <Route path='/en/work/amesankohjpCorporate' element={<AmesankohjpCorporateEn />} />
        <Route path='/en/work/aquadianaCorporate' element={<AquadianaCorporateEn />} />
        <Route path='/en/work/artdeliLp' element={<ArtdeliLpEn />} />
        <Route path='/en/work/daeyangEc' element={<DaeyangEcEn />} />
        <Route path='/en/work/daeyangSns' element={<DaeyangSnsEn />} />
        <Route path='/en/work/eurojcupTote' element={<EurojcupToteEn />} />
        <Route path='/en/work/hayashiseimenjoSns' element={<HayashiseimenjoSnsEn />} />
        <Route path='/en/work/imoriichibaEc' element={<ImoriichibaEcEn />} />
        <Route path='/en/work/imoriichibaTote' element={<ImoriichibaToteEn />} />
        <Route path='/en/work/japanfesNovelty' element={<JapanfesNoveltyEn />} />
        <Route path='/en/work/logotChara' element={<LogotCharaEn />} />
        <Route path='/en/work/marukinkaraageLp' element={<MarukinkaraageLpEn />} />
        <Route path='/en/work/orenorheingawaBlog' element={<OrenorheingawaBlogEn />} />
        <Route path='/en/work/ramennobuUniform' element={<RamennobuUniformEn />} />
        <Route path='/en/work/tagawaTote' element={<TagawaToteEn />} />
        <Route path='/en/work/tagawaUniform' element={<TagawaUniformEn />} />
        <Route path='/en/work/transfoodlevEc' element={<TransfoodlevEcEn />} />
        <Route path='/en/work/japanfesUniform' element={<JapanfesUniformEn />} />
        <Route path='/en/work/neotokyocardsEc' element={<NeotokyocardsEcEn />} />
        <Route path='/en/work/spogomiUniform' element={<SpogomiUniformEn />} />
        <Route path='/en/work/toiUniform' element={<ToiUniformEn />} />
        <Route path='/en/work/fckreisUniform' element={<FckreisUniformEn />} />
        <Route path='/en/work/amesankohProductDaruma' element={<AmesankohProductDarumaEn />} /> */}
        <Route path="/en/work/:slug" element={<WorkDetailTemplateEn />} />

        </Routes>
      </PageTurnTransition>
    </>
  )
}
export default App;
